// extracted by mini-css-extract-plugin
module.exports = {"row1":"ContactUs_row1__3oYzw","col1":"ContactUs_col1__2-GJt","row2":"ContactUs_row2__3UcvT","col2":"ContactUs_col2__mqXHa"};